import ProtonWebSDK, { LinkSession, ProtonWebLink } from '@proton/web-sdk'
import {PROTON_MAINNET_EPS,PROTON_MAINET_CHAINID, PROTON_APP_IDENTIFIER, PROTON_TESTNET_EP, PROTON_TESTNET_CHAINID} from "./../constants"


export class ProtonService{

  async logout(link: ProtonWebLink,session:LinkSession) {
    
    await link.removeSession("snipcoins", session.auth, PROTON_MAINET_CHAINID);
    window["proton"] = {link:null,session:null,connected:false}
    window.dispatchEvent(new CustomEvent(ProtonServiceEvent.PROTON_LOGOUT_SUCCESS))

  }

  async login(restoreSession = false) {
      
    console.log("ls session recover")
    if (restoreSession) { 

      try {

        const ls = localStorage;
        console.log(ls);

      } catch { 

        console.warn('Local storage not supported')

      }
    }

    const { link, session } = await ProtonWebSDK({
      linkOptions: {
        endpoints:PROTON_MAINNET_EPS,
        chainId:PROTON_MAINET_CHAINID,
        restoreSession,
      },
      transportOptions: {
        requestAccount: PROTON_APP_IDENTIFIER
      },
      selectorOptions: {
        appName: "snipcoins",
        appLogo: "https://snipcoins.com/snipcoins-icon.png",
        customStyleOptions: {
            modalBackgroundColor: "#F4F7FA",
            logoBackgroundColor: "#7040e2",
            isLogoRound: true,
            optionBackgroundColor: "white",
            optionFontColor: "black",
            primaryFontColor: "black",
            secondaryFontColor: "#6B727F",
            linkColor: "#752EEB"
        }
      }
    })
  
    console.log({link:link,session:session});  
    window["proton"] = {link:link,session:session,connected:true}
    if (session && link)window.dispatchEvent(new CustomEvent(ProtonServiceEvent.PROTON_LOGIN_SUCCESS))
    
  }

}

export const ProtonServiceEvent = {

    PROTON_LOGIN_SUCCESS:'protonservice.PROTON_LOGIN_SUCCESS',
    PROTON_LOGOUT_SUCCESS:'protonservice.PROTON_LOGOUT_SUCCESS'

}